module.exports = __webpack_public_path__ + "img/t2-endorsement-statement.01c5f2a2.png";